<template>
	<v-dialog v-model="dialogValue" max-width="1024" scrollable>
		<v-card>
			<v-card-title>
				<v-icon left>lock</v-icon>Cadastro de Usuário
				<v-spacer></v-spacer>
				<v-btn icon @click="hideDialog">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pb-0">
				<v-text-field v-model="usuario.nome" label="Nome" prepend-icon="person" type="text" required
					:disabled="loading" />
				<v-select prepend-icon="location_city" label="Cidade" v-model="usuario.cidade" :items="cidades"
					item-text="nome" item-value="nome" :disabled="loading"></v-select>
				<v-text-field v-model="usuario.email" label="E-mail" prepend-icon="email" type="email" required
					:disabled="loading" />
				<v-row v-if="!usuario.id">
					<v-col>
						<v-text-field v-model="senha" label="Senha" prepend-icon="lock"
							:type="show ? 'text' : 'password'" required :disabled="loading">
							<template v-slot:append>
								<v-icon color="primary" @click="show = !show">
									{{ show ? 'mdi-eye' : 'mdi-eye-off' }}
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
					<v-col>
						<v-text-field v-model="confirmaSenha" label="Confirmação Senha"
							:prepend-icon="senha === confirmaSenha ? 'lock' : 'lock'"
							:type="show2 ? 'text' : 'password'" required :disabled="loading">
							<template v-slot:append>
								<v-icon color="primary" @click="show2 = !show2">
									{{ show2 ? 'mdi-eye' : 'mdi-eye-off' }}
								</v-icon>
							</template>
						</v-text-field>
					</v-col>
				</v-row>
				<div class="lista-funcoes pa-0 ma-0">
					<v-checkbox label="Ativo" v-model="ativo" :disabled="loading" hide-details="" v-if="userAdmin"
						class="ma-0"></v-checkbox>
					<v-checkbox label="Admin" v-model="admin" :disabled="loading" hide-details="" class="ma-0"
						v-if="userMaster"></v-checkbox>
					<v-checkbox label="Relatórios" v-model="usuario.relatorios" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="PxAcertos" v-model="usuario.pxacertos" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Regras Trib." v-model="usuario.regrastrib" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Mercado Pago" v-model="usuario.mercadopago" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>

					<v-checkbox label="Integrações" v-model="usuario.integracoes" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Aplicativos" v-model="usuario.aplicativos" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Relatórios Padrões" v-model="usuario.relatoriosPadroes" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Consultar CPF" v-model="usuario.consultacpf" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Configurar Plug4Market" v-model="usuario.plugmarket" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Consulta Bloqueios" v-model="usuario.bloqueios" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="DDA" v-model="usuario.dda" :disabled="loading" hide-details="" class="ma-0"
						v-if="userMaster"></v-checkbox>
					<v-checkbox label="Pix" v-model="usuario.pix" :disabled="loading" hide-details="" class="ma-0"
						v-if="userMaster"></v-checkbox>
					<v-checkbox label="Nota Segura" v-model="usuario.notaSegura" :disabled="loading" hide-details=""
						class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Siczap" v-model="usuario.siczap" :disabled="loading" hide-details="" class="ma-0"
						v-if="userMaster"></v-checkbox>
					<v-checkbox label="Consultar Plug4Market" v-model="usuario.consultaPlugmarket" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Definir Plano de Fundo SIC" v-model="usuario.planoFundoSic" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-checkbox label="Central de Relatórios" v-model="usuario.usu_central_relatorios" :disabled="loading"
						hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
					<v-spacer />

				</div>
				<v-card class="pa-3 mt-5">
					<v-card-title class="pa-0">Registro de Terminal</v-card-title>
					<div class="d-flex justify-space-between">
						<div>
							<v-checkbox label="Gerar Token" v-model="usuario.usu_terminal_token_incluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
							<v-checkbox label="Desativar Token" v-model="usuario.usu_terminal_token_excluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
						</div>

						<div>
							<v-checkbox label="Incluir Empresa" v-model="usuario.usu_terminal_empresa_incluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
							<v-checkbox label="Excluir Impresa" v-model="usuario.usu_terminal_empresa_excluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
						</div>

						<div>
							<v-checkbox label="Incluir Conexão" v-model="usuario.usu_terminal_conexao_incluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
							<v-checkbox label="Excluir Conexão" v-model="usuario.usu_terminal_conexao_excluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
						</div>

						<div>
							<v-checkbox label="Incluir Database" v-model="usuario.usu_terminal_db_incluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
							<v-checkbox label="Excluir Database" v-model="usuario.usu_terminal_db_excluir"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
						</div>

						<div>
							<v-checkbox label="Alterar Qt. Máquinas" v-model="usuario.usu_terminal_qtmaquinas_modificar"
								:disabled="loading" hide-details="" class="ma-0" v-if="userMaster"></v-checkbox>
						</div>
					</div>
				</v-card>
				<v-card class="pa-3 mt-3">
					<v-card-title class="pa-0">Mensagens Notificações SIC</v-card-title>
					<div class="d-flex flex-row">
						<v-checkbox label="Notificar" v-model="usuario.mensagemNotificar" :disabled="loading"
							hide-details="" class="ma-0 mr-3" v-if="userMaster"></v-checkbox>
						<v-checkbox label="Alertar" v-model="usuario.mensagemAlertar" :disabled="loading"
							hide-details="" class="ma-0 mr-3" v-if="userMaster"></v-checkbox>
						<v-checkbox label="Bloquear" v-model="usuario.mensagemBloquear" :disabled="loading"
							hide-details="" class="ma-0 mr-3" v-if="userMaster"></v-checkbox>
					</div>
				</v-card>
				<v-card class="pa-3 mt-3">
					<v-card-title class="pa-0">Data Combinada</v-card-title>
					<v-row>
						<v-checkbox label="Combina Data" v-model="usuario.dataCombinada" :disabled="loading"
							hide-details="" class="ml-3 mr-5 mb-3" v-if="userMaster" />
						<p class="qtd-dias-label mt-5" v-if="usuario.dataCombinada">
							Quantidade de dias:
						</p>
						<div class="mt-3 ml-2 qtd-dias-input" v-if="usuario.dataCombinada">
							<v-text-field hide-details type="number" single-line dense :max="15" :min="1"
								v-model="dataCombinadaMax" />
						</div>
					</v-row>
				</v-card>
				<v-btn color="primary" v-if="userMaster && usuario.id" @click="alterarSenha()" class="mt-3"> Alterar
					senha </v-btn>
			</v-card-text>
			<v-card-actions>
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
				<v-spacer v-if="!loading"></v-spacer>
				<v-btn v-if="!loading" @click="sair">Sair</v-btn>
				<v-btn color="primary" v-if="!loading" @click="salvar">Salvar</v-btn>
			</v-card-actions>
			<RedefinirSenha :abrirDialog="abrir" @dialogClose="closeAlterarSenha" :id="usuario.id" tipo="usuario" />
		</v-card>
	</v-dialog>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import RedefinirSenha from './RedefinirSenha.vue'

export default {
	data: function () {
		return {
			loading: false,
			cidades: [
				{ uf: 'GO', nome: 'Jataí' },
				{ uf: 'GO', nome: 'Rio Verde' },
				{ uf: 'TO', nome: 'Palmas' },
			],
			abrir: false,
			senha: '',
			confirmaSenha: '',
			show: false,
			show2: false,
			dataCombinadaMax: 1
		}
	},
	components: {
		RedefinirSenha,
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState('usuarios', ['usuario', 'dialog']),
		dialogValue: {
			get() {
				return this.dialog
			},
			set(val) {
				this.setDialog(val)
			},
		},
		ativo: {
			get() {
				return this.usuario.ativo ?? true
			},
			set(val) {
				this.usuario.ativo = val
				this.setAtivo()
			},
		},
		admin: {
			get() {
				return this.usuario.admin
			},
			set(val) {
				this.usuario.admin = val
				this.setAdmin()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),

		async salvar() {
			if (this.usuario.id) {
				this.editar()
			} else {
				this.criar()
			}
		},
		async editar() {
			try {
				// eslint-disable-next-line no-console
				//console.log(this.axios.defaults.baseURL);

				this.loading = true
				await this.axios.put(`/usuarios/${this.usuario.id}`, this.usuario)
				this.$store.dispatch('showSuccess', 'Usuário alterado com sucesso')
				this.hideDialog()
				this.$emit('closeModal')
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async criar() {
			if (!(this.senha == this.confirmaSenha)) this.$store.dispatch('showError', 'As senhas não estão iguais!')
			else {
				try {
					this.loading = true
					this.usuario.ativo = this.ativo
					this.usuario.admin = this.admin
					await this.axios.post(`/usuarios`, this.usuario)
					this.$store.dispatch('showSuccess', 'Usuário criado com sucesso!')
					this.hideDialog()
					this.$emit('closeModal')
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.confirmaSenha = this.senha = ''
					this.loading = false
				}
			}
		},

		async setAtivo() {
			if (this.usuario.id) await this.setField('ativo', 'Ativo alterado com sucesso!')
		},
		async setAdmin() {
			if (this.usuario.id) await this.setField('admin', 'Admin alterado com sucesso!')
		},
		async setField(field, msg) {
			try {
				this.loading = true
				const params = {}
				params[field] = this.usuario[field]
				await this.axios.put(`/usuarios/${this.usuario.id}/${field}`, params)
				this.$store.dispatch('showSuccess', msg)
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		sair() {
			this.hideDialog()
		},
		alterarSenha() {
			this.abrir = true
		},
		closeAlterarSenha() {
			this.abrir = false
		},
	},
	watch: {
		dialogValue() {
			if (this.dialogValue) {
				this.dataCombinadaMax = this.usuario.dataCombinadaMax
			}

		},
		dataCombinadaMax() {
			if (this.dataCombinadaMax < 1 && this.dataCombinadaMax != '') {
				this.$nextTick(() => {
					this.dataCombinadaMax = 1
				});
			}
			if (this.dataCombinadaMax > 15) {
				this.$nextTick(() => {
					this.dataCombinadaMax = 15
				});
			}

			this.usuario.dataCombinadaMax = this.dataCombinadaMax
		}
	}
}
</script>

<style scoped>
.lista-funcoes {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 12px;
	gap: 8px;
}

.qtd-dias-label {
	color: rgba(0, 0, 0, 0.6);
	font-size: 16px;
	margin: 0;
}

.qtd-dias-input {
	max-width: 35px;
}
</style>